import { z } from 'zod';
import { TimestampSchema } from '../common';
import { EventId, SessionId, UserId } from '../ids';

export const BaseEventSchema = z.object({
  id: EventId,
  sessionId: SessionId,
  timestamp: TimestampSchema,
  userId: UserId.optional(), // who triggered the action
  version: z.number().int().positive().optional(),
});
